export function prependUrlProtocol(url, protocol = 'http') {
	let _url = url;
	if (!/^https?:\/\//i.test(_url)) {
		_url = `${protocol}://${_url}`;
	}
	return _url;
}
